import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { INotApplicableCriteria } from 'src/app/shared/models/not-applicable-criteria.model';

export const NOT_APPLICABLE_CRITERIA_API_ACTIONS = createActionGroup({
  source: 'Not Applicable Criteria API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: INotApplicableCriteria[] }>(),
  },
});
